import { Icon, IconButton, SliderModal, Text, HStack, VStack } from '@genial/components';
import { Utils, useBreakpointValue } from '@genial/utils';
import { Box } from 'native-base';
import React, { useMemo } from 'react';
import { Modal } from 'react-native';
import { useRecoilValue, useSetRecoilState } from 'recoil';

import { useRecoilQuery } from '../../../../../hooks/useRecoilQuery';
import { blockReasonModalState } from '../../../../../store/customer/atom';
import { customerBlockingReasonsQuery } from '../../../../../store/customerDetail/selector';

const Wrapper: React.FC<{ children: React.ReactNode; onDismiss: () => void }> = ({
  children,
  onDismiss,
}) => {
  const isMobile = useBreakpointValue({ base: true, sm: false });

  if (isMobile) {
    return (
      <SliderModal direction="top" onDismiss={onDismiss}>
        <Box borderTopRadius="md" backgroundColor="neutral.white" padding="inset.xs">
          {children}
        </Box>
      </SliderModal>
    );
  }

  return (
    <Box
      flex={1}
      alignItems="center"
      justifyContent="center"
      backgroundColor={Utils.ColorToken.WithOpacity('neutral.dark', 0.8)}>
      <Box
        backgroundColor="neutral.white"
        paddingX="inset.md"
        paddingY="inset.sm"
        borderRadius="sm"
        width="630px">
        {children}
      </Box>
    </Box>
  );
};

export const BlockReasonModal: React.FC = () => {
  const isMobile = useBreakpointValue({ base: true, sm: false });
  const { isOpen, customer } = useRecoilValue(blockReasonModalState);
  const setModalState = useSetRecoilState(blockReasonModalState);
  const { data: reasons, loading } = useRecoilQuery(
    customerBlockingReasonsQuery({
      customerId: customer?.customerId || 0,
    }),
    { if: () => !!customer?.customerId }
  );

  const handleModalClose = () => {
    setModalState({ isOpen: false, customer: undefined });
  };

  const reasonList = useMemo(
    () =>
      reasons?.map((reason, index) => (
        <HStack key={index} alignItems="center" space="stack.quarck" flex={1}>
          <Icon name="Warning" size="xxs" color="feedback.attention.default" />
          <Text>{reason}</Text>
        </HStack>
      )),
    [reasons]
  );

  return (
    <Modal visible={isOpen} onDismiss={handleModalClose} transparent>
      <Wrapper onDismiss={handleModalClose}>
        <VStack>
          <HStack alignItems="center" justifyContent="space-between" width="full">
            <HStack space="stack.quarck">
              <Icon name="Warning" size="sm" color="feedback.attention.default" />
              <VStack>
                <Text variant="semibold" fontSize="md" isLoading={loading}>
                  Bloqueio no Cadastro
                </Text>
                <Text fontSize="xs" isLoading={loading}>
                  {customer?.name}
                </Text>
              </VStack>
            </HStack>
            <IconButton
              testId="close-block-reason-modal"
              icon="Close"
              borderWidth={isMobile ? 0 : 1}
              borderColor="neutral.dark"
              borderRadius="full"
              padding="inset.quarck"
              iconSize={isMobile ? 'xs' : 'xxxxs'}
              iconColor="neutral.dark"
              onPress={handleModalClose}
            />
          </HStack>
          <Box
            width="full"
            borderTopColor="neutral.lightest"
            borderTopWidth="1"
            borderTopStyle="dotted"
            marginTop="inset.xs"
            marginBottom="inset.xs"
          />
          <VStack space="stack.xxxs">
            <Text variant="semibold" fontSize="md" isLoading={loading}>
              Motivos:
            </Text>

            {reasonList}
          </VStack>
          <HStack
            alignItems="center"
            space="stack.quarck"
            backgroundColor="feedback.gen.lightest"
            padding="inset.nano"
            borderRadius="sm"
            marginTop="inset.md">
            <Icon name="Info" size="xxs" color="brand.tertiary.principal" />
            <Text isLoading={loading}>
              Comunique seu cliente. Para suporte ou mais detalhes, fale com a equipe do Middle pelo
              e-mail: middleb2b@genial.com.vc.
            </Text>
          </HStack>
        </VStack>
      </Wrapper>
    </Modal>
  );
};
